import React from "react";

interface SkillIconProps {
  icon?: JSX.Element;
  img?: string;
  name: string;
}

const SkillIcon: React.FC<SkillIconProps> = ({ icon, img, name }) => {
  return (
    icon ?? (
      <img
        className="rounded-full"
        width="32"
        height="32"
        alt={name}
        src={img}
      />
    )
  );
};

export default SkillIcon;
